import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { FireBaseService } from './firebase.service';
import { WindowRef } from './shared.service';
import { DOCUMENT } from '@angular/common';
import { timer } from 'rxjs';
declare const FB: any;
@Injectable({
    providedIn: 'root',
})
export class FacebookService {
    private currentUser: any;
    private deviceDetail: any;
    constructor(
        private authService: AuthService,
        private fireBaseService: FireBaseService,
        private windowRef: WindowRef,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.authService.userProfile.subscribe((res) => (this.currentUser = res));
        this.fireBaseService.deviceDetailSubject.subscribe((res) => (this.deviceDetail = res));
    }

    initFb() {
        let fjs = this.document.getElementsByTagName('script')[0];
        if (this.document.getElementById('facebook-jssdk')) { return; }
        let js = this.document.createElement('script');
        js.id = 'facebook-jssdk';
        js.src = environment.production ? "https://connect.facebook.net/en_US/sdk.js" : "https://connect.facebook.net/en_US/sdk/debug.js";
        fjs.parentNode.insertBefore(js, fjs);
        if (typeof window !== 'undefined') {
            timer(100).subscribe(() => {
                window['fbAsyncInit'] = function () {
                    (window as any).FB.init({
                        appId: environment.facebookAppId,
                        cookie: true,
                        status: true,
                        xfbml: true,
                        version: 'v17.0',
                        autoLogAppEvents: true
                    });
                };
            })

        }
    }

    logEvent(eventName: any, params: any) {
        let _params: any = this.getBasicInfo();
        if (typeof window !== 'undefined') {
            if (window.sessionStorage.getItem('sai')) {
                _params['from_sap'] = true;
            }
            if (window.sessionStorage.getItem('rmf')) {
                let _data = JSON.parse(window.sessionStorage.getItem('rmf'));
                _params['from_rm'] = true;
                _params['rm_journeyType'] = _data.journeyType;
                _params['rm_id'] = _data.rmId;
                _params['rm_linkId'] = _data.linkId;
            }
            if (environment.app) {
                (window as any).facebookConnectPlugin.logEvent(
                    eventName,
                    { ..._params, ...params },
                    null
                );
            } else {
                (window as any).FB.AppEvents.logEvent(
                    eventName,
                    null,
                    { ..._params, ...params }
                );
            }
        }
    }
    private getBasicInfo() {
        let _props: any = {
            "verticalSource": this.verticalType(),
            "User Scope": this.currentUser?.scope || 'Guest',
            "device": this.deviceDetail?.device == 'Android' ? 'android' : this.deviceDetail?.device == 'iOS' ? 'ios' : this.deviceDetail?.device ? 'web' : 'NA',
        }
        if (this.windowRef.nativeWindow?.sessionStorage.getItem('campaign')) {
            _props.campaign = this.windowRef.nativeWindow?.sessionStorage.getItem('campaign')
        }
        return _props;
    }
    private verticalType(): string {
        let vertical = this.windowRef.nativeWindow?.localStorage.getItem(environment.verticalToken)
        let verticalName: string = ''
        switch (vertical) {
            case 'investment':
                verticalName = 'Investment'
                break;
            case 'trading':
                verticalName = 'Trading'
                break;
            case 'mutual-funds':
                verticalName = 'Mutual Funds'
                break;
            case 'digital-savings':
                verticalName = 'Digital Savings'
                break;
            default:
                verticalName = 'Common'
                break;
        }
        return verticalName
    }

}